import React from 'react'
import Alert from '@react/react-spectrum/Alert'

function ErrorMessage(error) {
  if (error.error?.networkError?.statusCode === 401) {
    return (
      <Alert variant='info' header='Welcome'>
        We need to sign you in first. Redirecting...
      </Alert>
    )
  } else if (
    error.networkError?.statusCode === 404 ||
    error.error?.networkError?.statusCode === 404 ||
    error.error?.message === 'Failed to fetch'
  ) {
    return (
      <Alert variant='info' header='Just a moment, please'>
        We're updating our backend, please try again in a minute.
        <br />
        If you keep seeing this message, let us know at <a href='mailto:demosystem@adobe.com'>demosystem@adobe.com</a>.
      </Alert>
    )
  } else {
    return (
      <Alert variant='error' header='Error'>
        {error.message}
      </Alert>
    )
  }
}

export default ErrorMessage
